import type { ContractingFilters } from "@/types/domain";

/**
 * Map the shared ContractingFilters object to the query-param record expected
 * by the backend `/contractings/getAll` and `/dashboard/getDashboardData`
 * endpoints (singular id keys, comma-joined arrays).
 */
export function toContractingParams(filters: ContractingFilters) {
  return {
    searchProfileId: filters.searchProfileId,
    page: filters.page,
    size: filters.size,
    sortBy: filters.sortBy,
    sortOrder: filters.sortOrder,
    search: filters.search,
    onlyInterests: filters.onlyInterests,
    departmentId: filters.departmentId,
    provinceId: filters.provinceId,
    districtId: filters.districtId,
    procuringEntityId: filters.procuringEntityId,
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    status: filters.status,
    stage: filters.stage,
    subject: filters.subject,
    keywords: filters.keywords,
    contratadomaxdays: filters.contratadomaxdays,
    amountMin: filters.amountMin,
    amountMax: filters.amountMax,
    assignedTo: filters.assignedTo,
    scope: filters.scope,
    qualification: filters.qualification,
  };
}
